export const deepClone = <T>(obj: T): T => {
  if (obj === null) return null as T
  if (typeof obj !== 'object') return obj
  const clone = { ...(obj as Record<string, unknown>) }
  Object.keys(clone).forEach(
    (key) => (clone[key] = typeof clone[key] === 'object' ? deepClone(clone[key]) : clone[key])
  )
  if (Array.isArray(obj)) {
    ;(clone as { length: number }).length = obj.length
    return Array.from(clone as unknown as ArrayLike<unknown>) as T
  }
  return clone as T
}

export const arrays_are_equal = (
  arrayA: unknown[] | null | undefined,
  arrayB: unknown[] | null | undefined
): boolean => {
  if ((!arrayA && !arrayB) || (arrayA?.length === 0 && arrayB?.length === 0)) {
    return true // both are undefined or empty arrays
  }
  if ((arrayA && !arrayB) || (!arrayA && arrayB) || arrayA?.length !== arrayB?.length) {
    return false // only one is undefined or empty array
  }

  for (let i = 0; i < (arrayA?.length || 0); i++) {
    if (!arrayB || typeof arrayB[i] === 'undefined') {
      return false
    }
    const itemA = arrayA?.[i]
    const itemB = arrayB[i]
    if (Array.isArray(itemA) && !arrays_are_equal(itemA, itemB as unknown[])) {
      return false
    }
    if (typeof itemA === 'object' && itemA !== null && !objects_are_equal(itemA, itemB)) {
      return false
    }
    if (typeof itemA !== 'object' && itemA !== itemB) {
      return false
    }
  }
  // hmmm if it is not an array it always returns true
  return true
}

export const objects_are_equal = (objectA: unknown, objectB: unknown): boolean => {
  if (!objectA || !objectB) {
    return objectA === null && objectB === null
  }
  if (typeof objectA !== 'object' || typeof objectB !== 'object') {
    return objectA === objectB
  }
  const objA = objectA as Record<string, unknown>
  const objB = objectB as Record<string, unknown>
  const keysA = Object.keys(objA)
  if (keysA.length !== Object.keys(objB).length) {
    return false
  }
  for (const key of keysA) {
    if (!(key in objB)) {
      return false
    }
    if (Array.isArray(objA[key]) && !arrays_are_equal(objA[key] as unknown[], objB[key] as unknown[])) {
      return false
    }
    if (typeof objA[key] === 'object' && !objects_are_equal(objA[key], objB[key])) {
      return false
    }
    if (typeof objA[key] !== 'object' && objA[key] !== objB[key]) {
      return false
    }
  }
  return true
}
